import SuperRepository from '../superRepository'

export default new (class RolesRepository extends SuperRepository {
  baseUri() {
    return 'user_role'
  }
})()